import Button from '@material-ui/core/Button';
import { mainTheme } from '../../settings';
import { MuiThemeProvider } from '@material-ui/core/styles';

export default (props) => (
    <MuiThemeProvider theme={mainTheme}>
        <Button {...props}>{props.title}</Button>
    </MuiThemeProvider>
)